<template>
  <div class="surface-post-author">
    <a v-if="isRegistered" :href="authorProfileUrl" target="_blank" data-bridged-link="profile">
      <avatar-image :user="author" :width="16" :height="16" />
      <span class="post-author-name">{{ authorName }}</span>
    </a>
    <span v-else class="author-info"
      ><avatar-image :user="null" :width="16" :height="16" /><span class="post-author-name">{{
        authorName
      }}</span></span
    >
    <relative-time v-if="!isBackchannel && updatedAt" class="post-author-time" :datetime="updatedAt" data-autorefresh />
    <div v-if="isBackchannel" class="post-author-time">
      {{ createdAtDateString }}
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapGetters, mapState, mapActions } from 'vuex'
import { hyphenatedCurrentLocale as locale } from 'bits/current_locale'
import AvatarImage from 'vuecomponents/avatar_image'
import IntlMixin from 'vuemixins/intl_mixin'
import RelativeTime from 'vuecomponents/relative_time'
import { anonymous, blankUser } from 'bits/user_model'

export default {
  components: { AvatarImage, RelativeTime },
  mixins: [IntlMixin],
  props: ['post', 'user'],
  computed: {
    ...mapState(['tenant']),
    ...mapGetters(['isBackchannel']),
    ...mapGetters('userContributor', ['getUserById']),
    author() {
      return this.getUserById(this.post.author_id) || blankUser
    },
    authorName() {
      return this.isRegistered ? this.author.name || this.author.username : anonymous
    },
    authorProfileUrl() {
      return this.author.profile_url
    },
    isRegistered() {
      return this.author.registered || !!this.author.registered_at
    },
    updatedAt() {
      return this.post.content_updated_at || this.post.created_at
    },
    createdAtDateString() {
      let createdAtDate = new Date(this.post.created_at)
      let today = new Date()
      let options = {}
      if (today.toDateString() === createdAtDate.toDateString()) {
        options = {
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        }
      } else {
        options = {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        }
      }

      return new Intl.DateTimeFormat(locale, options).format(createdAtDate)
    },
  },
  methods: {
    ...mapActions('userContributor', ['fetchUser']),
  },
  mounted() {
    this.fetchUser(this.post.author_id)
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/3/modules/all';

.surface-post-author {
  display: flex;
  align-items: center;
  font-size: 12px;
  overflow: hidden;

  a,
  a:visited {
    color: inherit;

    &:hover {
      text-decoration: underline;
      color: inherit;
    }
  }

  a,
  .author-info {
    display: flex;
    align-items: center;
    @include ellipsify-text;
    .post-author-name {
      @include ellipsify-text;
    }
  }

  img {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    margin-right: 0.5em;
  }

  .post-author-time {
    @include muted-type;
    margin-left: 0.5em;
    font-size: 11px;
    @include ellipsify-text;
  }
}
</style>
